// extracted by mini-css-extract-plugin
export var csatScore = "_l0-5";
export var header = "_l0-1";
export var panelWrapper = "_l0-2";
export var postPreview = "_l0-3";
export var rightContent = "_l0-0";
export var wrappingText = "_l0-4";